var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrain3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 42,
    viewBox: "0 0 46 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5617 18.4609C30.0508 17.9392 29.429 17.5392 28.7423 17.2907C28.0557 17.0422 27.3219 16.9516 26.5954 17.0256C25.8689 17.0996 25.1684 17.3362 24.546 17.718C23.9235 18.0998 23.395 18.6169 22.9997 19.2309C22.6046 18.6167 22.0762 18.0995 21.4537 17.7176C20.8312 17.3357 20.1307 17.099 19.4042 17.025C18.6776 16.951 17.9438 17.0417 17.2571 17.2903C16.5704 17.5389 15.9486 17.939 15.4377 18.4609C14.5161 19.4035 14 20.6695 14 21.9879C14 23.3063 14.5161 24.5722 15.4377 25.5149L22.9997 33.1999L30.5637 25.5159C31.4847 24.5726 32.0002 23.3064 31.9998 21.988C31.9994 20.6696 31.4833 19.4037 30.5617 18.4609Z",
    fill: "#D4D4D8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 41H5C3.93913 41 2.92172 40.5786 2.17157 39.8284C1.42143 39.0783 1 38.0609 1 37V1H17L22 9H45V37C45 38.0609 44.5786 39.0783 43.8284 39.8284C43.0783 40.5786 42.0609 41 41 41Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain3);
export default __webpack_public_path__ + "static/media/train3.bc03828703041c05bc2f3db7e666f28c.svg";
export { ForwardRef as ReactComponent };